import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { MediaViewerCommentSidebarProps } from '@confluence/editor-features/entry-points/MediaViewerCommentSidebarProps.ts';

export const MediaViewerCommentSidebar: LoadableType<MediaViewerCommentSidebarProps> = LoadableLazy(
	{
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-MediaViewerCommentSidebar" */ '../src/components/MediaViewerCommentSidebar.tsx'
				)
			).MediaViewerCommentSidebar,
	},
);
